<template>
  <v-app>
    <v-main>
      <v-sheet
        v-if="!this.$vuetify.theme.dark && _iOS && _nS"
        color="primary"
        height="44"
      />
      <transition name="slide-x-transition" mode="out-in">
        <router-view />
      </transition>
    </v-main>
  </v-app>
</template>

<style>
/* dirty ie-korjaus https://github.com/vuetifyjs/vuetify/issues/9130 */
.v-card__text,
.v-card__title {
  word-break: normal !important; /* maybe !important  */
}

body {
  background-color: #37394d;
}

/* Dirty iPhone korjaus https://github.com/vuetifyjs/vuetify/issues/6355 */
.v-bottom-navigation {
  height: auto !important;
}

.v-bottom-navigation >>> .v-btn__content {
  padding-top: 10px;
  padding-bottom: 10px;
  margin-bottom: constant(
    safe-area-inset-bottom
  ); /* move footer up on iPhone X - iOS 11.0 */
  margin-bottom: env(
    safe-area-inset-bottom
  ); /* move footer up on iPhone X - iOS 11.2 */
}
</style>

<script>
import store from "@/store";

export default {
  name: "App",
  created() {
    // TODO TEEMAKOODI HUONO
    if (store.state.appconfig.theme == "system")
      this.$vuetify.theme.dark = window.matchMedia(
        "(prefers-color-scheme: dark)"
      ).matches;
    else this.$vuetify.theme.dark = store.state.appconfig.darkmode;

    window.matchMedia("(prefers-color-scheme: dark)").addListener(() => {
      if (store.state.appconfig.theme == "system") {
        this.$vuetify.theme.dark = window.matchMedia(
          "(prefers-color-scheme: dark)"
        ).matches;
      }
    });
  },
  computed: {
    _iOS() {
      return (
        (/iPad|iPhone|iPod/.test(navigator.platform) ||
          (navigator.platform === "MacIntel" &&
            navigator.maxTouchPoints > 1)) &&
        !window.MSStream
      );
    },
    _nS() {
      return !!navigator.standalone;
    }
  }
};
</script>
